import {observable} from "@nx-js/observer-util";
import {Services} from "../../Services";
import {IOfferProductModel} from "../../../models/offer/product/IOfferProductModel";

export class OfferProductService {
    public static products: IOfferProductModel[] = observable([]);

    public static dispose(): void {
        this.products = observable([]);
    }

    public static init(): void {

    }

    /**
     * store
     */

    public static storeAll(products: IOfferProductModel[]): IOfferProductModel[] {
        for (let key in products)
            products[key] = this.store(products[key]);

        return Services.storeAll(products);
    }

    public static store(product?: IOfferProductModel): IOfferProductModel {
        if (product) {
            product = Services.store("id", this.products, product);
        }
        return product;
    }
}